import type { ArrowDirection } from '../components/atomic/buttons/arrows/Arrows';
import type { NavBarTab } from '../components/composite/nav/nav_bar/NavBar';
import {
  isVinylMusicDelivery,
  toggleVinylMusic,
} from '../../assets/preloadSounds';
import {
  closeInfoPopup,
  toggleInfoPopup,
} from '../shared/infoPopup/infoPopupControllerActions';
import { nextPageForDirection } from '../shared/pagination/clampPageChange';
import type { DeliveryListScreenModel } from './DeliveryListScreenModelScreen';

export class DeliveryListScreenController {
  constructor(private readonly model: DeliveryListScreenModel) {}

  handleNavigate = (direction: ArrowDirection) => {
    if (!this.model.hasDeliveries || this.model.againOpen || this.model.infoOpen) {
      return;
    }
    const maxIndex = Math.max(0, this.model.deliveryCount - 1);
    this.model.setSelectedIndex((current) =>
      nextPageForDirection(direction, current, maxIndex),
    );
    this.model.onNavigate?.(direction);
  };

  handleInfoButtonClick = () => {
    if (this.model.againOpen) {
      return;
    }
    toggleInfoPopup(this.model);
  };

  handleInfoClose = () => {
    closeInfoPopup(this.model);
  };

  handleTabChange = (tab: NavBarTab) => {
    this.model.onTabChange?.(tab);
  };

  handleAgainClick = () => {
    if (!this.model.hasDeliveries || !this.model.canReplay) {
      return;
    }
    this.model.setAgainOpen(true);
  };

  handleAgainNo = () => {
    this.model.setAgainOpen(false);
  };

  handleAgainYes = () => {
    if (!this.model.hasDeliveries || !this.model.canReplay) {
      return;
    }
    this.model.onReplayDelivery?.(this.model.giantId, this.model.orderIndex);
  };

  handleMoreDetails = () => {
    if (!this.model.hasDeliveries) {
      return;
    }
    this.model.onOpenDetails?.(this.model.giantId, this.model.orderIndex);
  };

  handleToggleVinylMusic = () => {
    if (
      this.model.itemFrame !== 'opened' ||
      !isVinylMusicDelivery(this.model.giantId, this.model.orderIndex)
    ) {
      return;
    }
    toggleVinylMusic();
  };
}
